<script setup>
import RoleCards from '@/views/apps/roles/RoleCards.vue'
import AdvancedUserList2 from '@/views/apps/user/list/AdvancedUserManager2.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'roles',
  },
})
</script>

<template>
  <VRow>
    <VCol cols="12">
      <h4 class="text-h4 mb-1">
       {{ $t('Roles List') }}
      </h4>
      <p class="text-body-1 mb-0">
        {{ $t("A role provided access to predefined menus and features so that depending on assigned role an administrator can have access to what he need")}}
      </p>
    </VCol>

    <!-- 👉 Roles Cards -->
    <VCol cols="12">
      <RoleCards />
    </VCol>

    <VCol cols="12">
      <h4 class="text-h4 mb-1 mt-6">
        {{ $t("Total users with their roles") }}
      </h4>
      <p class="text-body-1 mb-0">
        {{ $t("Find all of your company’s administrator accounts and their associate roles.") }}
      </p>
    </VCol>

    <VCol cols="12">
      <!-- 👉 User List  -->
       <AdvancedUserList2></AdvancedUserList2>

    </VCol>
  </VRow>
</template>
